import { useEffect } from "react";

export default function useScrollReveal(animationClass) {
  useEffect(() => {
    const elements = document.querySelectorAll(`.${animationClass}`);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [animationClass]);
};

